import { Card, Container, Row } from "react-bootstrap"
import { SpendConversionsByDay } from "./charts/SpendConversionsByDay"
import { SpendByNetworkBar } from "./charts/SpendByNetworkBar"
import { SpendByAudienceBar } from "./charts/SpendByAudienceBar"
import { SpendByAudience } from "./charts/SpendByAudience"
import SpendPanels from "./charts/SpendPanels"
import PerUserTrend from "./charts/PerUserTrend"
import MarginTrend from "./charts/MarginTrend"
import DirectMailPanel from "./charts/DirectMailPanel"

/*
    Spend tab (MPN-1530 §4).

    Opens with the two grouped panels the ticket specifies -- Full Campaign, then Current
    Billing Period when the contract has one -- rather than the two loose rows of HUD
    cards it had before. SpendHud and BudgetHud are retired: their numbers are the panels'
    numbers, and the old Budget HUD read the contract-wide SpendAccount balance and called
    it the campaign's budget.
*/

const Spend = ({ data, launchId }: { data: any; launchId?: number }) => {
  return (
    <Container className="d-flex flex-column gap-3 mb-5" style={{ minHeight: 364 }}>
      <SpendPanels data={data} />

      <Row className="flex-grow-1">
        <Card className="custom-card overflow-hidden mb-0 border border-2">
          <Card.Header>
            <Card.Title>Margin Trend</Card.Title>
          </Card.Header>
          <Card.Body>
            <MarginTrend data={data} />
          </Card.Body>
        </Card>
      </Row>

      <Row className="flex-grow-1">
        <Card className="custom-card overflow-hidden mb-0 border border-2">
          <Card.Header className="justify-content-between">
            <Card.Title>Spend By Network</Card.Title>
          </Card.Header>
          <Card.Body>
            <SpendByNetworkBar series={data["spend-by-network"]} />
          </Card.Body>
        </Card>
      </Row>

      {/* Only renders once a campaign has mailed (MPN-1706). */}
      <Row className="flex-grow-1">
        <DirectMailPanel launchId={launchId} />
      </Row>

      <Row className="flex-grow-1">
        <Card className="custom-card mb-0 border border-2">
          <Card.Header>
            <Card.Title>Spend By Day</Card.Title>
          </Card.Header>
          <Card.Body>
            <SpendConversionsByDay series={data["spend-conversions-by-day"]} />
          </Card.Body>
        </Card>
      </Row>

      <Row className="flex-grow-1">
        <Card className="custom-card mb-0 border border-2">
          <Card.Header>
            <Card.Title>Spend Per User Over Time</Card.Title>
          </Card.Header>
          <Card.Body>
            <PerUserTrend data={data} mode="spend" />
          </Card.Body>
        </Card>
      </Row>

      <Row className="flex-grow-1">
        <Card className="custom-card mb-0 border border-2">
          <Card.Header>
            <Card.Title>Impressions Per User Over Time</Card.Title>
          </Card.Header>
          <Card.Body>
            <PerUserTrend data={data} mode="impressions" />
          </Card.Body>
        </Card>
      </Row>

      <Row className="flex-grow-1">
        <Card className="custom-card overflow-hidden mb-0 border border-2">
          <Card.Header className="justify-content-between">
            <Card.Title>Spend By Ad Group</Card.Title>
          </Card.Header>
          <Card.Body>
            <SpendByAudienceBar series={data["spend-by-audience"]} />
          </Card.Body>
        </Card>
      </Row>

      <Row className="flex-grow-1">
        <Card className="custom-card overflow-hidden mb-0 border border-2">
          <Card.Header className="justify-content-between">
            <Card.Title>Spend By Ad Group, By Day</Card.Title>
          </Card.Header>
          <Card.Body className="p-0">
            <div className="px-3 mt-sm-0 mt-3">
              <SpendByAudience series={data["spend-by-audience"]} />
            </div>
          </Card.Body>
        </Card>
      </Row>
    </Container>
  )
}

export default Spend
